import { utils, writeFile } from 'xlsx'

import { type IServicePrice } from '@/app/types/adminsTypes'

export const onBuildPriceFile = (data: IServicePrice[], date: string) => {
    const fileName = date.split('T')[0]
    const ws = utils.json_to_sheet(data, { skipHeader: true })
    const wb = utils.book_new()
    utils.book_append_sheet(wb, ws)
    writeFile(wb, `${fileName}.xlsx`)
}
